export const environment = {
  production: true,
  hmr: false,
  base_url: window.location.protocol + "//" + window.location.host,
  base_url_azure_api: window.location.protocol + "//" + window.location.host,
};
